define('BookingEngine/app-BEBasket/main',['./settings', '../app-BEBasket/module', '../app-General/dialog', 'jquery-ui'], function (settings, beBasket, dialog) {
    return {
        run: function () {
            var container = $(settings.container);

            if (container.length === 0) {
                window.log('No basket Container found. BookingEngine/app-BEBasket will not be loaded.');

                return;
            }

            window.log('Loading app-BEBasket.');

            container.find(".btnItinerary").on("click", function (e) {
                e.preventDefault();
                dialog.showDialog("/basketitinerary/index");
            });
            
            window.loadedModules("BookingEngine/app-BEBasket");

            if ($("#booknowactive").is(":visible")) {
                beBasket.updateBasket();
            }
        }
    }
});
